import React, { useState, useEffect } from "react";
import "./aboutus.css";
import Footer from "../../components/footer/footer";
import Header from "../../components/Navbar"; // make sure the path is correct
import Rightarrow from "../../myimgs/rightarrow.png";
import Makabout from "../../myimgs/Maskgroup.png";
import sale from "../../myimgs/sale.png";
import Banks from "../../myimgs/banks.png";
import m1 from "../../myimgs/m1.png";
import m2 from "../../myimgs/m2.png";
import m3 from "../../myimgs/m3.png";

function ProfilePage() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    if (storedName) {
      setUserName(storedName);
    }
  }, []);

  return (
    <>
      <Header />
      {/* <div className="container-fluid bannerbg">
        <div className="row">
          <div className="col-md-12">
            <h3>{userName || "Guest"}</h3>
            <p>
              Home <img src={Rightarrow} alt=""></img> About Us
            </p>
          </div>
        </div>
      </div> */}
      <div className="container abot">
        <div className="row abots">
          <div className="col-md-12">
            {/* <h5>About Us</h5>
            <h2>Twoffers</h2> */}
          </div>
        </div>
        <div className="row aboup">
          <div className="col-md-7">
            <p>
              Twoffers is a trusted name in real estate Listings,
              connecting property sellers with motivated buyers nationwide. We
              specialize in marketing residential, commercial, and land
              properties to a wide audience, ensuring maximum exposure and
              competitive bidding.
            </p>
            <p>
              Our team combines deep market expertise with innovative marketing
              strategies to deliver fast, transparent, and profitable
              transactions. From property listing to closing, we handle every
              detail with professionalism and integrity, making the selling
              process simple and stress-free.
            </p>
            <p>
              At Twoffers, our mission is to help you achieve the best
              possible value for your property — with speed, efficiency, and
              trust.
            </p>
          </div>
          <div className="col-md-5">
            <img src={Makabout} alt="" />
          </div>
        </div>
        <div className="row abots">
          <div className="col-md-12">
            <h5>We are Offering the Best Real Estate</h5>
            <h2>Property Services</h2>
          </div>
        </div>
      </div>

      <div className="row features-section">
        <div className="col-md-6">
          <div className="feature-card card2">
            <img src={Banks} alt="Capabilities" />
            <div>
              <h4>Home For Buy</h4>
              <p>Discover stunning homes ready for you to buy today.</p>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="feature-card card2">
            <img src={sale} alt="Transparency" />
            <div>
              <h4>Home For Sale</h4>
              <p>Here are the beautiful homes that are available for sale.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="row features-section">
        <div className="col-md-4">
          <div className="feature-card">
            <img src={m3} alt="Capabilities" />
            <h4>Capabilities</h4>
            <p>
              Technology to help you do it all – browse auction, place bids and
              more – anywhere, anytime.
            </p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="feature-card">
            <img src={m2} alt="Transparency" />
            <h4>Transparency</h4>
            <p>
              We ensure fairness by maintaining complete transparency at every
              stage of the auction process.
            </p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="feature-card">
            <img src={m1} alt="Choices" />
            <h4>Choices</h4>
            <p>
              Explore your options. Browse a broad range of properties to find
              your next investment.
            </p>
          </div>
        </div>
      </div>
      {/* <div className="container-fluid aboubottom">
          <li>
            <h3>225,000+</h3>
            <p>Properties Sold</p>
          </li>
          <li>
            <h3>1.7+</h3>
            <p>Million Users</p>
          </li>
          <li>
            <h3>3,000+</h3>
            <p>
              Properties Listed at <br></br>
              any given time
            </p>
          </li>
          <li>
            <h3>10+</h3>
            <p>
              Years of<br></br>
              Experience
            </p>
          </li>
      </div> */}
      <Footer />
    </>
  );
}

export default ProfilePage;
